<template>
	<div id="content_body">
		<header-layout :pageHeaderStyle="pageHeaderStyle" :pageHeaderBg="pageHeaderBg" :pageHeaderSpacing="pageHeaderSpacing" :pageHeaderContainer="pageHeaderContainer" :pageTitle="pageTitle" :pageSubtitle="pageSubtitle" :pageIcon="pageIcon"></header-layout>
		<div class="container mt-n15">
			<!-- invoice -->
			<div class="card">
				<vue-collapsible-panel-group>
				<vue-collapsible-panel>
					<template #title>{{ $t('panel.form') }}</template>
					<template #content>
						<div class="card-header">
							<!-- @submit.prevent="handleSubmit()" -->
							<b-form ref="instanceForm" id="instanceForm" autocomplete="off" >
								<!-- Flash -->
								<div v-if="$store.getters.flash.msg" class="alert alert-danger" role="alert" v-html="$store.getters.flash.msg" />
								<div class="form-row">

									<div class="col-md-6">
										<b-form-group class="small mb-1">
											<label>
												{{ $t(instanceClassAttr.instanceClass+'.dateStart')}}
											</label>
											<input type="date" v-model="instance.dateStart" class="form-control" lang="fr" :class="{'is-invalid': v$.instance.dateStart.$error, 'is-valid': (!v$.instance.dateStart.$error && v$.instance.dateStart.$dirty) }" :disabled="typeView=='show'"/>
											<span class="small text-muted d-md-block" v-if="v$.instance.dateStart.$error">
												{{ v$.instance.dateStart.$errors[0].$message }}
											</span>
										</b-form-group>				
									</div>
									<div class="col-md-6">
										<b-form-group class="small mb-1">
											<label>
												{{ $t(instanceClassAttr.instanceClass+'.dateEnd')}}
											</label>
											<input type="date" v-model="instance.dateEnd" class="form-control" lang="fr" :class="{'is-invalid': v$.instance.dateEnd.$error, 'is-valid': (!v$.instance.dateEnd.$error && v$.instance.dateEnd.$dirty) }" :disabled="typeView=='show'"/>
											<span class="small text-muted d-md-block" v-if="v$.instance.dateEnd.$error">
												{{ v$.instance.dateEnd.$errors[0].$message }}
											</span>
										</b-form-group>				
									</div>
									<div class="col-md-4">
										<b-form-group class="small mb-1">
											<label>
												{{ $t(instanceClassAttr.instanceClass+'.minAmount')}}
											</label>
											<input type="number" step="any" v-model="minAmount" class="form-control" :class="{'is-invalid': v$.instance.minAmount.$error, 'is-valid': (!v$.instance.minAmount.$error && v$.instance.minAmount.$dirty) }" :disabled="typeView == 'show'" @input="amountToLetter($event, 'amount')" @change="amountLetter = {}"/>
											<span class="small text-muted d-md-block" v-if="v$.instance.minAmount.$error">
												{{ v$.instance.minAmount.$errors[0].$message }}
											</span>
											<span v-if="amountLetter && amountLetter.amount != '' " class="amount-letter">
												{{amountLetter.amount}}
											</span>

										</b-form-group>				
									</div>
									<div class="col-md-4">
										<b-form-group class="small mb-1">
											<label>
												{{ $t(instanceClassAttr.instanceClass+'.percentRefund')}}
											</label>
											<input type="number" v-model="instance.percentRefund" class="form-control" :class="{'is-invalid': v$.instance.percentRefund.$error, 'is-valid': (!v$.instance.percentRefund.$error && v$.instance.percentRefund.$dirty) }" :disabled="typeView == 'show'"/>
											<span class="small text-muted d-md-block" v-if="v$.instance.percentRefund.$error">
												{{ v$.instance.percentRefund.$errors[0].$message }}
											</span>
										</b-form-group>				
									</div>
									
									<div class="col-md-4">
										<b-form-group class="small mb-1">
											<label>
												{{ $t(instanceClassAttr.instanceClass+'.username')}}
											</label>
											<input type="text" v-model="instance.username" class="form-control" disabled/>
										</b-form-group>
									</div>
			
								</div>
								
							</b-form>
							<div class="row">
								<div class="col-md-4" align="left">
									<b-button v-if="typeView == 'show' && $store.getters.isAuthorized(['ROLE_MANAGER'])" class="btn btn-success" @click="valid" >
										<span>
											<fa icon="check"/>
											{{ $t("mvtrefund.button.valid")}}
										</span>
									</b-button>
								</div>
								<div class="col-md-4" align="center">

									<b-button v-if="typeView != 'show'" class="btn btn-success" 
										@click="handleSubmit()" >
										<span v-if="typeView == 'new'">
											<fa icon="check"/>
											{{ $t("default.button.create")}}
										</span>
										<span v-if="typeView == 'edit'">
											<fa icon="check"/>
											{{ $t("default.button.update")}}
										</span>
									</b-button>
									&ensp;
									<b-button v-if="typeView == 'edit'" class="btn btn-dark" @click="typeView = 'show'; mvtRefundItemsEdit = [];" >
										<span>
											<fa icon="times"/>
											{{ $t("default.button.cancel")}}
										</span>
									</b-button>
									
									<b-button v-if="typeView == 'show' && $store.getters.isAuthorized(['ROLE_MANAGER'])" class="btn btn-primary" 
										@click="typeView = 'edit'" >
										<span>
											<fa icon="edit"/>
											{{ $t("default.button.edit")}}
										</span>
									</b-button>

								</div>
								<div v-if="typeView == 'show'" class="col-md-4" align="right">
									<b-button id="print"
										variant="primary" class="btn btn-info" type="button" @click="produce()">
										<fa icon="print"/>
										&nbsp;
										{{$t('mvtrefund.button.print')}}
									</b-button>
									<modal-pdf-viewer 
										ref="componentModalPdf" 
										:pdfSrc="pdfSrc"
										:pdfName="pdfName"
									/>
								</div>
							</div>
							
						</div>
					</template>
				</vue-collapsible-panel>
				<br>
				<vue-collapsible-panel v-if="typeView == 'edit'">
					<template #title>{{ $t('panel.edit') }}</template>
					<template #content>
						<div v-if="instance.mvtRefundItems.length == 0 && typeView == 'edit' && $store.getters.isAuthorized(['ROLE_MANAGER'])" class="table-responsive" align="center">
							<b-button class="btn btn-warning" @click="create" >
								<span>
									<fa icon="refresh"/>
									{{ $t("mvtrefund.button.create")}}
								</span>
							</b-button>
						</div>
						<div v-if="instance.mvtRefundItems.length > 0" class="table-responsive">
							<table id="instanceTable" class="table table-sm table-striped table-bordered table-hover mb-0">
								<thead class="border-bottom thead-light">
									<tr class="small text-uppercase text-muted">
										<th scope="col" width="30%">
											{{ $t('mvtrefunditem.prsPerson')}}
										</th>
										<th scope="col" width="15%" class="align-right">
											{{ $t('mvtrefunditem.amountTot')}}
										</th>
										<th scope="col" width="15%" class="align-right">
											{{ $t('mvtrefunditem.amountRefund')}}
										</th>
										<th scope="col" width="40%" class="align-center">
											{{ $t('mvtrefunditem.justificatif')}}
										</th>
										<th scope="col" width="8%" class="align-center">
											{{ $t('default.actions')}}
										</th>
									</tr>
								</thead>
								<tbody>
									<!-- LIST EDIT -->
									<tr class="border-bottom" v-for="mvtRefundItemEdit in mvtRefundItemsEdit" :key="mvtRefundItemEdit.prsPerson">
										<td>
											<div class="font-weight-bold">
												{{mvtRefundItemEdit.prsPersonLib}}
											</div>
										</td>
										<td>
											<div class="font-weight-bold align-right">
												{{$store.getters.formatAmount(mvtRefundItemEdit.amountTot)}}
											</div>
										</td>
										<td>
											<div class="font-weight-bold align-right">
												<input type="number" step="any" v-model="mvtRefundItemEdit.amountRefund" class="form-control" @input="amountToLetter($event, 'amountRefund')" @change="amountLetter = {}"/>
											</div>
										</td>
										<td>
											<div class="font-weight-bold">
												<input type="text" v-model="mvtRefundItemEdit.justificatif" class="form-control"/>
											</div>
										</td>
										<td class="align-center">
											<div class=""> 
												<button class="btn btn-danger btn-icon btn-xs" @click="removeRow(mvtRefundItemEdit)">
													<fa icon="minus"/>
												</button>
											</div>
										</td>
									</tr>
									<tr v-if="amountLetter && amountLetter.amountRefund != '' " class="border-bottom table-warning">
										<td align="center" colspan="5" >
											<span class="amount-letter">
												{{amountLetter.amountRefund}}
											</span>
										</td>
									</tr>
									<tr v-if="typeView != 'show'" class="border-bottom table-warning">
										<td v-show="activeAddRow" align="center" colspan="5" >
											<auto-search :paramsSearch="paramsSearch" @updateOnClick="addRow" :key="autoSearchKey"/>
										</td>
										<td v-show="!activeAddRow" align="center" colspan="5"
										>
											<b-button class="btn btn-sm btn-success" 
												@click="activeAddRow=true; autoSearchKey++;" >
												<span>
													<fa class="fa-lg" icon="plus-circle"/>
												</span>
											</b-button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</template>
				</vue-collapsible-panel>

				<br>
				<vue-collapsible-panel>
					<template #title>{{ $t('panel.data') }}</template>
					<template #content>
						<div class="card-body p-4 p-md-5">
							<div class="datatable">
								<!-- TOTAL -->
								<table id="instanceTable" class="table table-sm table-striped table-bordered table-hover mb-0">
									<tbody>
										<tr v-if="amountMvtTot > 0" class="border-bottom table-warning">
											<td align="center" colspan="1" >
												<div class="align-right" >
													{{$t('mvtrefund.amountRefundTot')}}
												</div>
											</td>
											<td align="center" colspan="1" >
												<div class="align-right">
													{{$store.getters.formatAmount(amountRefundTot)}}
												</div>
											</td>
											<td align="small center" colspan="1" >
												<div class="align-right" >
													{{$t('mvtrefund.amountMvtTot')}}
												</div>
											</td>
											<td align="center" colspan="1" >
												<div class="align-right">
													{{$store.getters.formatAmount(amountMvtTot)}}
												</div>
											</td>
										</tr>
									</tbody>
								</table>
								<datatable-instance
									:instanceClassAttr="instanceClassRefundItem"
									ref="componentDatatableInstance"
								/>
							</div>

						</div>
					</template>
				</vue-collapsible-panel>
			</vue-collapsible-panel-group>

				
			</div>
		</div>
	</div>
</template>
<script>
	import Header from '@/layouts/templates/Header.vue';
	import AutoSearch from '@/components/templates/AutoSearch.vue';
	import ModalPdfViewer from '@/components/templates/Modals/ModalPdfViewer.vue'
	import DatatableInstance from '@/components/templates/datatables/DatatableInstance.vue'
	import { useVuelidate } from '@vuelidate/core'
	import { required, email,minLength, maxLength } from '@vuelidate/validators'
	export default {
		name: 'mvtRefund',
		props: {
			itemId: {
				type: Number,
				default: NaN,
				required: false
			},
		},
		setup () { return { v$: useVuelidate() }},
		components: {
			'header-layout': Header,
			'modal-pdf-viewer': ModalPdfViewer,
			'datatable-instance': DatatableInstance,
			'auto-search': AutoSearch
		},
		data() {
			return {
				pageHeaderStyle: process.env.VUE_APP_PAGE_HEADER_STYLE,
				pageHeaderBg: process.env.VUE_APP_PAGE_HEADER_BG,
				pageHeaderSpacing: 'pb-10',
				pageHeaderContainer: 'container',
				pageSubtitle: this.$t('mvtrefund.label'),
				pageTitle: this.$t('mvtrefund.show'),
				pageIcon: 'reply',
				instanceClassAttr: {
					instanceClass: 'mvtrefund'
				},
				instanceClassRefundItem: {
					instanceClass: 'mvtrefunditem',
					typeItems: 'itemsInit',
					actCol: {
						actDisplay: false, 
						thCol: '10%',
						thClass: 'align-center',
						// actAlign: 'right',
						actAdd: false, 
						actGet: false, 
						actEdit: false, 
						actDel: false
					},
					attrsList:[
						{attrName:'prsPersonLib', thStyle: {width:'30%'}, thClass:'align-center'},
						{attrName:'amountTot', thStyle: {width:'15%'}, thClass:'align-center', searchable: true, sortable: true},
						{attrName:'amountRefund', thStyle: {width:'15%'}, thClass:'align-center', searchable: true, sortable: true},
						{attrName:'justificatif', thStyle: {width:'40%'}, thClass:'align-center', searchable: true, sortable: true}
					]
				},

				instance: {
					mvtRefundItems: [],
				},
				paramsSearch: {
					placeholder: 'Search Bénéficiare',
					instanceClass: 'prsperson',
					attrsSearch : ['firstName', 'lastName'],
					attrView: 'fullName',
					filterList: [],
					btnReturn: false,
					icon: 'user',
				},
				activeAddRow: false,
				autoSearchKey: 0,
				mvtRefundItemsEdit: [],
				mvtRefundItemsInit: [],
				minAmount:2000000,
				amountMvtTot:0,
				amountRefundTot:0,
				vueRules: {},
				amountLetter: {},
				typeView: 'new',
				pdfSrc:'',
				pdfName:'FICHE DE CALCUL',				
			}
		},
		validations () {
			return this.vueRules
		},
		watch: {
			minAmount: function() {
				this.instance.mvtRefundItems = this.mvtRefundItemsInit.filter(item => item.amountTot > this.minAmount)

				this.instance.mvtRefundItems.forEach(
					mvtRefundItem => {
					this.amountMvtTot = this.amountMvtTot+ mvtRefundItem.amountTot
					this.amountRefundTot = this.amountRefundTot+ mvtRefundItem.amountRefund
				})

				this.$refs.componentDatatableInstance.refreshDataTable(this.instance.mvtRefundItems);

			}
		},
		created (){
			this.vueRules = this.createVeerules()
		},
		async mounted () {
			this.$store.dispatch('initFlash');

			if(this.$store.getters.loggedIn) {
				this.amountMvtTot = 0
				this.amountRefundTot = 0
				if(this.itemId && !isNaN(this.itemId)){
					this.typeView = 'show'
					await this.$store.dispatch('axiosGet', {
						domain: 'mvtrefund',
						id: this.itemId
					})
					.then(response => {
						this.instance = response.data
						this.pageSubtitle = this.instance.lib
						this.instance.dateStart = this.instance.dateStart.split('T')[0]
						this.instance.dateEnd = this.instance.dateEnd.split('T')[0]
						this.minAmount = this.instance.minAmount

						this.getRefundItems()
						this.getPersonList()
					})
					.catch(error => {
						console.log('error catch get mvtrefund by itemId == ', error.message)
					})
				}
				else {
					await this.$store.dispatch('axiosGet', { url: '/api/mvtrefund/create'
					})
					.then(response => {
						if(response.data){
							// console.log('response.data == ', response.data)
							this.instance = response.data.mvtRefund;
							this.instance.dateStart = this.instance.dateStart.split('T')[0]
							this.instance.dateEnd = this.instance.dateEnd.split('T')[0]
							let prs = Object.values(response.data.mapCl);
							this.instance.mvtRefundItems = []

							prs.forEach(p => {
								if(p.amount >= this.instance.minAmount){
									let mvtRefundItem = {
										prsPerson: p.id,
										prsPersonLib: p.lib,
										amountTot: p.amount,
										amountRefund: (p.amount * (this.instance.percentRefund /100)),
										justificatif: 'Ristourne - '+this.instance.dateEnd.split('-')[0],
										username:this.$store.getters.username,
										active:true
									}

									this.amountMvtTot = this.amountMvtTot+ mvtRefundItem.amountTot
									this.amountRefundTot = this.amountRefundTot+ mvtRefundItem.amountRefund
									this.instance.mvtRefundItems.push(mvtRefundItem)
								}
							})
							this.$refs.componentDatatableInstance.refreshDataTable(this.instance.mvtRefundItems);
							this.mvtRefundItemsInit = this.instance.mvtRefundItems
						}

					})
					.catch(error => {
						console.log('error catch - mvtrefund - creates == ', error.message)
					})
					this.instance.username = this.$store.getters.username
					this.instance.active = true // on laisse à false apres valid on calcul le montant total 
				}
				this.amountToLetter({target:{value:this.amountMvtTot?.toString()}}, 'amountMvtTot')
				
				this.amountToLetter({target:{value:this.amountRefundTot?.toString()}}, 'amountRefundTot')
				
			}
		},
		methods: {

			// GET LIST ITEMS
			async getRefundItems(){						
				let strParams = "typeRender=list"
				strParams = strParams+"&attrOrder=amountRefund&typerOrder=asc"			
				strParams = strParams+"&params1=mvtRefund.id&valParams1="+ this.itemId +"&logParams1=eqL"
				
				await this.$store.dispatch('axiosGet', { 
					url: '/api/mvtrefunditem/getbycriteria?' + strParams
				})
				.then(res => {
					if(res.data){
						this.instance.mvtRefundItems = res.data
						this.$refs.componentDatatableInstance.refreshDataTable(this.instance.mvtRefundItems);
						this.amountMvtTot = 0
						this.amountRefundTot = 0
						this.instance.mvtRefundItems.forEach(
							mvtRefundItem => {

							this.amountMvtTot = this.amountMvtTot+ mvtRefundItem.amountTot
							this.amountRefundTot = this.amountRefundTot+ mvtRefundItem.amountRefund
						})
					}
				})
				.catch(error => {
					console.log('error catch mvtRefund getCriteria == ', error.message)
				})
			},
			async create(){
				this.$store.dispatch('loading', this.$t('toast.loading.message'))
				await this.$store.dispatch('axiosGet', { url: '/api/mvtrefund/create?id='+this.instance.id
				})
				.then(response => {
					// console.log('response == ', response)
					if(response.data){
						// console.log('response.data == ', response.data)
						/*this.instance = response.data.mvtRefund;
						this.instance.dateStart = this.instance.dateStart.split('T')[0]
						this.instance.dateEnd = this.instance.dateEnd.split('T')[0]*/
						let prs = Object.values(response.data.mapCl);
						this.instance.mvtRefundItems = []
						prs.forEach(p => {
							if(p.amount >= this.instance.minAmount){
								let mvtRefundItem = {
									prsPerson: p.id,
									prsPersonLib: p.lib,
									amountTot: p.amount,
									amountRefund: (p.amount * (this.instance.percentRefund /100)),
									justificatif: 'Ristourne - '+this.instance.dateEnd.split('-')[0],
									username:this.$store.getters.username,
									active:true
								}
								this.amountMvtTot = this.amountMvtTot+ mvtRefundItem.amountTot
								this.amountRefundTot = this.amountRefundTot+ mvtRefundItem.amountRefund
								this.instance.mvtRefundItems.push(mvtRefundItem)
							}
						})
						this.$refs.componentDatatableInstance.refreshDataTable(this.instance.mvtRefundItems);
						this.mvtRefundItemsInit = this.instance.mvtRefundItems
						this.$store.dispatch('unloading')
					}

				})
				.catch(error => {
					console.log('error catch - mvtrefund - creates == ', error.message)
				})
				// this.instance.username = this.$store.getters.username
				// this.instance.active = true // on laisse à false apres valid on calcul le montant total 
				this.amountToLetter({target:{value:this.amountMvtTot?.toString()}}, 'amountMvtTot')
				
				this.amountToLetter({target:{value:this.amountRefundTot?.toString()}}, 'amountRefundTot')
			},
			async getPersonList(){
				let strParams = "typeRender=list"
				strParams = strParams+"&attrOrder=firstName&typerOrder=asc"			
				// CL -> 2
				strParams = strParams+"&aliasList=_prsType"
				strParams = strParams+"&params1=_prsType.id&valParams1="+2+"&logParams1=eqL"
				strParams = strParams+"&params2=active&valParams2="+true+"&logParams2=eqB"
					
				await this.$store.dispatch('axiosGet', { 
					url: '/api/prsperson/getbycriteria?' + strParams
				})
				.then(response => {
					this.paramsSearch.filterList = response.data
				})
				.catch(error => {
					console.log('error catch paramsSearch.filterList == ', error.message)
				})

			},
			removeRow(row){
				this.mvtRefundItemsEdit = this.mvtRefundItemsEdit.filter(item => item.prsPerson !== row.prsPerson)
			},
			addRow(row){
				if(row){
					let refundItemExitEdit = this.mvtRefundItemsEdit.filter(item => item.prsPersonLib == row.fullName)
					if(refundItemExitEdit && refundItemExitEdit[0] ){
						this.$store.dispatch('showToast', {
							type: 'warning', message: row.fullName +' déja choisis'
						});
					}
					else {
						let refundItemExit = this.instance.mvtRefundItems.filter(item => item.prsPersonLib == row.fullName)

						let mvtRefundItem = {
							prsPerson: row.id,
							prsPersonLib: row.fullName,
							amountTot: 0,
							amountRefund: 0,
							justificatif: 'Ristourne - '+this.instance.dateEnd.split('-')[0],
							username: this.$store.getters.username,
							active: true
						}
						if(refundItemExit && refundItemExit[0] && refundItemExit[0].id){
							mvtRefundItem = {
								id: refundItemExit[0].id,
								prsPerson: row.id,
								prsPersonLib: row.fullName,
								amountTot: refundItemExit[0].amountTot,
								amountRefund: refundItemExit[0].amountRefund,
								justificatif: refundItemExit[0].justificatif,
								username: refundItemExit[0].username,
								active: refundItemExit[0].active
							}

						}

						this.mvtRefundItemsEdit.push(mvtRefundItem)
					}
				
				}
				if(this.activeAddRow)
					this.activeAddRow = false
				else
					this.activeAddRow = true
			},
			createVeerules(){
				let rules = {
					instance: {
						percentRefund: {required},
						minAmount: {required},
						dateStart: { required },
						dateEnd: {required},
						username: {required},
					}
				}
				return rules
			},
			async amountToLetter(e, attrName) {
				if(e.target.value && e.target.value.length > 2 && attrName && attrName != ''){
					await this.$store.dispatch('axiosGet', { url: '/api/sequence/convert?amount='+e.target.value
					})
					.then(response => {
						if(response.data && response.data.results)
							this.amountLetter[attrName] = response.data.results
					}).catch(error => {
						console.log('error catch convert amount == ', error.message)
					})
				}
			},
			async valid() {
				let result = false // await this.v$.$validate()
				
				if(this.amountMvtTot > 0 && this.amountRefundTot >0 ){
					this.instance.amountTot = this.amountMvtTot
					this.instance.amountTotRefund = this.amountRefundTot
					this.instance.active = true
					result = true
				}
				if (!result)
					return
				else{
					this.$store.dispatch('initFlash');
					this.$store.dispatch('loading')
					this.axiosPost()
				}

			},
			async handleSubmit() {
				this.instance.minAmount = this.minAmount
				const result = await this.v$.$validate()
				if (!result)
					return
				else{
					this.$store.dispatch('initFlash');
					this.$store.dispatch('loading')
					this.axiosPost()
				}
			},
	
			async axiosPost() {
				try {
					if(this.itemId && !isNaN(this.itemId)){
						// TRT 
						for(let i = 0; i < this.mvtRefundItemsEdit.length; i++) {
							if(this.mvtRefundItemsEdit[i] && this.mvtRefundItemsEdit[i].id){
								for(let j = 0; j < this.instance.mvtRefundItems.length; j++) {
									if(this.instance.mvtRefundItems[j].id == this.mvtRefundItemsEdit[i].id)
										this.instance.mvtRefundItems[j] = this.mvtRefundItemsEdit[i] 
								}
							}
							else 
								this.instance.mvtRefundItems.push(this.mvtRefundItemsEdit[i])
						}

						await this.$store.dispatch('axiosPut', {
							domain: 'mvtrefund',
							data: this.instance,
							id:this.itemId
						})
						.then(res => {
							this.$nextTick(() => {
								let msg = this.$t("mvtrefund.label") + " "+this.itemId;
								if(res.data && res.data.error){
									msg = msg+ ' '+ res.data.error;
									this.$store.dispatch('showToast', {
										type: 'warning', message: msg
									});
									this.$router.push('/refund/show/'+this.itemId)
								}
								else{
									this.$store.dispatch('showToast', {
										type: 'success', message: this.$t('toast.updated.message', { obj: msg})
									});
									this.typeView = 'show'
									this.$router.push('/refund/show/'+this.itemId)
									this.$nextTick(() => {
										this.getRefundItems();
									});
									// this.$router.go(0)
								}
								this.$store.dispatch('unloading')
							});
						})
						.catch(error => {
							console.log('error axiosPut === ', error)
							this.$store.getters.getErrorMsgFormatted(error);
							this.$store.dispatch('unloading')
						})
					}
					else {
						await this.$store.dispatch('axiosPost', {
							domain: 'mvtrefund',
							data: this.instance
						})
						.then(res => {
							this.$nextTick(() => {
								let msg = this.$t("mvtrefund.label") + " "+res.data.id;
								if(res.data && res.data.error){
									msg = msg+ ' '+ res.data.error;
									this.$store.dispatch('showToast', {
										type: 'warning', message: msg
									});
									this.$router.push('/refund/show/'+res.data.id)
								}
								else{
									this.$store.dispatch('showToast', {
										type: 'success', message: this.$t('toast.created.message', { obj: msg})
									});
									// this.$router.go(0)
									this.typeView = 'show'
									this.$router.push('/refund/show/'+res.data.id)
								}
								this.$store.dispatch('unloading')
							});
						})
						.catch(error => {
							console.log('error axiosPost === ', error)
							this.$store.getters.getErrorMsgFormatted(error);
							this.$store.dispatch('unloading')
						})
					}
					
				}
				catch (e) {
					console.log('Error ', e)
				}

			},
			async produce() {
				this.$store.dispatch('loading', this.$t('toast.produce.message'))
				let modelName = 'FICHE DE CALCUL DES RISTOURNES DU '+ this.$moment(this.instance.dateStart).format(this.$store.getters.formatDateShort) + ' AU '+ this.$moment(this.instance.dateEnd).format(this.$store.getters.formatDateShort)

				let attrsRepList = ['prsPerson', 'amountTot', 'amountRefund', 'justificatif']
				let attrsRepLibList = ['Bénéficiare', 'Solde Annuel', 'Montant de la ristourne', 'Observation']
				
				let	detailsTop = '<FONT size=4><b>'+modelName+' </b> </FONT>';

				let detailsTopC1 = '<i> '+ this.$t('mvtrefund.minAmount') +' : </i> <b> ' +this.$store.getters.formatAmount(this.instance?.minAmount) + '</b>';


				detailsTopC1 = detailsTopC1 +'<br><i> '+ this.$t('mvtrefund.percentRefund') +' : </i> <b> ' +this.instance.percentRefund?.toString() + '</b>';

				let	detailsTopC2 ='<i> Bamako le, </i> <b>' + this.$moment(this.instance.dateCreated).format(this.$store.getters.formatDateShort) + '</b>';

				let trFoot = ''

				trFoot = '<i> '+ this.$t('mvtrefund.amountMvtTot') +' : </i> <b>' +this.$store.getters.formatAmount(this.amountMvtTot) + '</b>';
				
				if(trFoot != '')
					trFoot = trFoot + '<br>'
				trFoot = trFoot + '<i> '+ this.$t('mvtrefund.amountRefundTot') +' : </i> <b>' +this.$store.getters.formatAmount(this.amountRefundTot) + '</b>';

				let	detailsBot = '<i><b> '+this.amountLetter.amountRefundTot +'</b> </i>';
				
				let libBot = ''
			
				let strParams = "jasper=LIC&typeList=criteria&strFormat=PDF"

				if(detailsTop != '')
					strParams = strParams +"&detailsTop="+detailsTop
				if(detailsTopC1 != '')
					strParams = strParams +"&detailsTopC1="+detailsTopC1
				if(detailsTopC2 != '')
					strParams = strParams +"&detailsTopC2="+detailsTopC2
				if(trFoot != '')
					strParams = strParams +"&trFoot="+trFoot

				if(libBot != '')
					strParams = strParams +"&libBot="+libBot

				if(detailsBot != '')
					strParams = strParams +"&detailsBot="+detailsBot
				// if(detailsBot3C != '')
				// 	strParams = strParams +"&detailsBot3C="+detailsBot3C
				

				let strParamsForms = "params1=mvtRefund.id&valParams1="+this.itemId +"&logParams1=eqL"
				strParamsForms = strParamsForms + "&attrsRepList=" +attrsRepList.toString()+"&attrsRepLibList="+attrsRepLibList.toString()
				strParams = strParams +"&"+strParamsForms

				strParams = strParams + "&titreDoc="+ this.$t(this.instanceClassAttr.instanceClass +'.mvtRefundItems')

				let fileName = modelName
				strParams = strParams + "&fileName="+ fileName
				// strParams = strParams + "&storeName=" + '<FONT size=1><i>*** '+this.instance.prsStore?.storeName +' ***</i></FONT> '
				await this.$store.dispatch('axiosGet', {
					url: '/api/mvtrefunditem/produce?' + strParams, strResponseType: 'blob'
				})
				.then(response => {
					var fileURL = window.URL.createObjectURL(new Blob([response.data]));
					this.pdfName = fileName+'.pdf'
					this.pdfSrc = fileURL
					this.$nextTick(()=> {
						this.$refs.componentModalPdf.modalToggle();
					});
					
				})
				.catch(error => {
					console.log('error catch == ', error.message)
				})
				this.$store.dispatch('unloading')
			},
		}

	}

</script>